import { useCallback, useState } from 'react';
import { useAuth0 } from '../../auth';
import { YellowButton } from '../button/button';
import { LoginSignupModal } from './components/login-signup-modal';
import { UnauthedModal } from './components/unauthed-modal';

type LoginSignupButtonProps = {
  children?: React.ReactNode | React.ReactNode[] | string;
  label?: React.ReactNode | React.ReactNode[] | string;
  Button?: () => React.ReactElement;
  type?: string;
};

export const LoginSignupButton = ({
  Button: ButtonComponent,
  children,
  label,
  type,
}: LoginSignupButtonProps) => {
  const { isAuthenticated, isLoading: authIsLoading } = useAuth0();
  const [modalOpen, setModalOpen] = useState(false);

  const Button = ButtonComponent || YellowButton;

  const handleOpen = useCallback(() => {
    setModalOpen(true);
  }, [setModalOpen]);

  const handleClose = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  if (authIsLoading || !isAuthenticated) {
    return (
      <>
        <Button onClick={handleOpen}>{label}</Button>
        {type === 'create' && (
          <UnauthedModal onLogin={handleOpen} open={modalOpen} onClose={handleClose} />
        )}
        {!type && <LoginSignupModal onLogin={handleOpen} open={modalOpen} onClose={handleClose} />}
      </>
    );
  }

  return <>{children}</>;
};
